import StoreUtil from '@/stores/StoreUtil'
import { reactive, toRefs } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

/**
 * アカウント登録 / 招待 / チーム参加処理を行う場合に利用するhook
 */
export default function useEnterAccount() {
  const enterAccountStore = StoreUtil.useStore('EnterAccountStore')
  const messageDialogStore = StoreUtil.useStore('MessageDialogStore')
  const ErrorStore = StoreUtil.useStore('ErrorStore')
  const router = useRouter()
  const { t } = useI18n()

  const state = reactive({
    /**
     * アカウント登録 / チームへの参加処理を行っている最中かどうか
     */
    isSendingEnterAccount: false,
  })

  /**
   * アカウント登録 / チームへの参加を行う
   * enterAccountStore.submit()を実行しているので、
   * 参加時のプロパティはStoreの状態を参照する
   * 実行に成功したらCompletePageに遷移する
   */
  const enterAccount = async () => {
    state.isSendingEnterAccount = true
    const submitResult = await enterAccountStore.submit()
    if (submitResult.isSuccess) {
      await router.replace({
        name: enterAccountStore.isInvitedUser ? 'InviteCompletePage' : 'CompletePage',
      })
    } else {
      let dialogOptions = {}
      switch (submitResult.res.response.data.error_code) {
        case '400_0001': {
          dialogOptions = {
            title: t('ConfirmationPage.parameterInvalid.title'),
            message: t('ConfirmationPage.parameterInvalid.message'),
            status: 'error',
          }
          break
        }
        case '409_0000': {
          dialogOptions = {
            title: t('ConfirmationPage.lineIdIsAlreadyUsed.title'),
            message: t('ConfirmationPage.lineIdIsAlreadyUsed.message'),
            status: 'error',
          }
          break
        }
        case '400_0042': {
          ErrorStore.setConfig(
            `tokenInvalid.${enterAccountStore.isInvitedUser ? 'invite' : 'register'}`,
          )
          router.replace({ name: 'ErrorPage' })
          return submitResult
        }
        case '400_0033': {
          dialogOptions = {
            title: t('ConfirmationPage.exceedUserError.title'),
            message: t('ConfirmationPage.exceedUserError.messageForInvite'),
            status: 'error',
          }
          break
        }
        case '400_0066': {
          dialogOptions = {
            title: t('EnterAccountPage.isNotFriendError.title'),
            htmlMessage: t('EnterAccountPage.isNotFriendError.message', [
              process.env.VUE_APP_FLUX_ADD_LINE_FRIEND_URL,
            ]),
            status: 'error',
          }
          break
        }
        case '400_0139': {
          dialogOptions = {
            title: t('EnterAccountPage.failedToCreateMultipleOrganizations.title'),
            htmlMessage: t('EnterAccountPage.failedToCreateMultipleOrganizations.message'),
            status: 'error',
          }
          break
        }
        case 'NETWORK_ERROR': {
          dialogOptions = {
            title: t('dialog.netWorkError.title'),
            message: t('dialog.netWorkError.message'),
            status: 'error',
          }
          break
        }
        default: {
          dialogOptions = {
            title: t('dialog.unknownError.title'),
            message: t('dialog.unknownError.message', [submitResult.res.response.data.error_code]),
            status: 'error',
          }
          break
        }
      }
      await messageDialogStore.openWithSettings(dialogOptions)
      state.isSendingEnterAccount = false
    }
    return submitResult
  }
  return {
    enterAccount,
    ...toRefs(state),
  }
}
